import React from 'react';

function IDE() {
  return (
    <div className="font-change">
      <h1 className="ide-title">Test Your Code</h1>
      <div className="container-ide">
        <div className="box"></div>
        <div className="frame-box">
          <iframe 
            src="https://codesandbox.io/embed/react-new?fontsize=14&hidenavigation=1&theme=dark"
            className="iframe-style"
            title="React Code Editor"
            allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
            sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
            loading="lazy"
          />
        </div>
        <div className="box"></div>
      </div>
    </div>
  );
}

export default IDE;